// GAVION recruiting: « Recruiting » (admins only).
export const recruitingEn = {
  title: "Recruiting",
  intro:
    "Published postings appear on gavion.ai within 5 minutes; applications from the site land here. Admins only.",
  badge: "%{smart_count} new application |||| %{smart_count} new applications",
  tabs: { postings: "Postings", applications: "Candidates" },
  posting_status: { draft: "Draft", published: "Published", closed: "Closed" },
  employment_type: {
    full_time: "Full time",
    part_time: "Part time",
    contract: "Contract",
    commission: "Commission",
    internship: "Internship",
  },
  remote: { onsite: "On site", hybrid: "Hybrid", remote: "Remote" },
  // GAVION manual-candidates: where the candidate came from
  source: {
    website: "Website",
    indeed: "Indeed",
    referral: "Referral",
    other: "Other",
  },
  add: {
    button: "Add a candidate",
    title: "Add a candidate",
    description:
      "A candidate received outside the website (Indeed, a referral…). They are reviewed by the AI and kept 12 months, like the others.",
    fields: {
      uid: "Identifier",
      name: "Name",
      posting_id: "Posting",
      source: "Source",
      contact: "Email or phone",
      email: "Email",
      phone: "Phone",
      availability: "Availability (optional)",
      profile_url: "Profile link (optional)",
      message: "Message / notes (optional)",
      cv: "Résumé (optional)",
      letter: "Cover letter (optional)",
    },
    choose_posting: "Choose a posting…",
    contact_hint: "Email or phone: at least one of the two.",
    profile_url_hint: "An https:// address (Indeed, LinkedIn…).",
    file_hint: "PDF, DOC or DOCX, 2 MB at most.",
    save: "Add",
    cancel: "Cancel",
    added_toast: "Candidate added. The AI review follows in a few minutes.",
    errors: {
      required: "Required.",
      invalid: "Invalid value.",
      invalid_email: "Invalid email address.",
      invalid_phone: "Invalid North American number (10 digits).",
      invalid_profile_url: "The link must start with https://.",
      contact_required: "Enter an email or a phone number.",
      too_long: "Too long.",
      file_type: "Only PDF, DOC or DOCX files are accepted.",
      file_size: "The file must be 2 MB at most.",
    },
  },
  application_status: {
    new: "New",
    interview: "Interview",
    offer: "Offer",
    hired: "Hired",
    rejected: "Rejected",
  },
  postings: {
    new: "New posting",
    empty: "No posting yet. Create one with « New posting ».",
    col_title: "Posting",
    col_status: "Status",
    col_published: "Published on",
    col_applications: "Applications",
    edit: "Edit",
    publish: "Publish",
    close: "Close",
    republish: "Republish",
    delete: "Delete",
    view_on_site: "View on the site",
    delete_title: "Delete this draft?",
    delete_body: "The posting « %{title} » will be deleted.",
    cancel: "Cancel",
    published_toast:
      "Posting published: it shows on the site within 5 minutes.",
    closed_toast: "Posting closed: it leaves the site within 5 minutes.",
    deleted_toast: "Draft deleted.",
  },
  form: {
    create_title: "New posting",
    edit_title: "Edit the posting",
    french: "French (required)",
    english: "English (optional)",
    title_fr: "Title",
    title_en: "Title (EN)",
    description_fr: "Description (Markdown)",
    description_en: "Description (EN, Markdown)",
    requirements_fr: "Requirements (Markdown)",
    requirements_en: "Requirements (EN, Markdown)",
    pay_text_fr: "Pay (free text)",
    pay_text_en: "Pay (EN)",
    pay_hint: "E.g. $45,000 – $55,000 + commissions",
    employment_type: "Employment type",
    location: "Location",
    location_hint: "E.g. Montréal (hybrid)",
    remote: "Work mode",
    slug: "Address on the site",
    slug_hint:
      "Lowercase letters, digits and dashes. Blank = taken from the French title.",
    slug_locked:
      "This posting has been published: its address is locked so shared links keep working.",
    public_url: "Public address: %{url}",
    preview: "Preview",
    edit_tab: "Write",
    save: "Save",
    saved_toast: "Posting saved.",
    cancel: "Cancel",
  },
  applications: {
    empty: "No application.",
    filter_posting: "Posting",
    filter_status: "Status",
    all_postings: "All postings",
    spontaneous: "Spontaneous application",
    all_statuses: "All statuses",
    col_date: "Received on",
    col_name: "Name",
    col_posting: "Posting",
    col_status: "Status",
    col_cv: "CV",
    col_availability: "Availability",
    has_cv: "CV attached",
    not_found: "This application no longer exists.",
    select_hint: "Pick an application to open it.",
    col_score: "AI score",
    sort_by_score: "Sort by AI score",
    review_pending: "Review in progress",
    review_none: "No score",
  },
  detail: {
    contact: "Contact",
    email: "Email",
    phone: "Phone",
    language: "Language",
    received: "Received on %{at}",
    message: "Message",
    no_message: "No message.",
    open_cv: "Open the CV",
    open_letter: "Open the letter",
    cover_letter: "Cover letter",
    availability: "Availability for an interview",
    no_cv: "No CV attached.",
    status: "Status",
    notes: "Notes",
    no_notes: "No note.",
    note_placeholder: "Add a note…",
    add_note: "Add the note",
    delete: "Delete",
    delete_title: "Delete this application?",
    delete_body:
      "The application of %{name}, its notes and its CV will be deleted for good.",
    cancel: "Cancel",
    deleted_toast: "Application deleted.",
    purge_on: "Deleted automatically on %{date}",
    kept_hired: "Kept: hired",
    close: "Close",
    languages: { fr: "French", en: "English" },
    profile: "Profile",
    open_profile: "Open the profile",
    manual_message: "Message / notes",
  },
  ai_review: {
    title: "AI review (indicative)",
    disclaimer: "Sorting aid only. A person decides.",
    rerun: "Review again",
    requested: "Review requested. The result arrives in a few minutes.",
    none: "Not reviewed yet. Click « Review again ».",
    pending: "Review in progress… (a few minutes)",
    unreadable: "Unreadable CV, read it yourself.",
    failed: "The review failed. Try « Review again ».",
    posting_changed: "Posting changed since the review",
    score: "%{score} / 100",
    reviewed_at: "Reviewed on %{at}",
    verdict: { strong: "Strong", consider: "Consider", weak: "Weak" },
    rating: {
      met: "Met",
      partial: "Partial",
      missing: "Missing",
      unknown: "Unknown",
    },
    col_requirement: "Requirement",
    col_rating: "Result",
    col_evidence: "Evidence from the documents",
    strengths: "Strengths",
    concerns: "Points to check",
    questions: "Interview questions",
  },
  erase: {
    title: "Erase a candidate",
    hint: "Erases every application sent from this email address, their notes, CVs and letters (Law 25). Companies and contacts are not touched.",
    email: "Candidate's email address",
    reason: "Reason",
    ack: "I understand this action cannot be undone.",
    button: "Erase the applications",
    done: "%{smart_count} application erased |||| %{smart_count} applications erased",
    files:
      "%{smart_count} file queued for deletion |||| %{smart_count} files queued for deletion",
  },
  errors: {
    forbidden: "Admins only.",
    not_found: "Not found: the page may have changed. Reload it.",
    invalid_posting: "Check the « %{field} » field.",
    slug_taken: "Another posting already uses this address.",
    slug_locked:
      "This posting has been published: its address can no longer change.",
    invalid_transition: "This action is not possible for this posting.",
    posting_not_deletable:
      "Only a draft without application can be deleted. Close the posting instead.",
    invalid_note: "The note is empty or too long (5,000 characters at most).",
    invalid_status: "Unknown status.",
    cv_unavailable: "The CV is not available.",
    invalid_email: "Invalid email address.",
    invalid_reason: "Pick a reason.",
    too_soon: "A new review was already requested less than a minute ago.",
    invalid_application: "Check the « %{field} » field.",
    file_upload_failed: "Uploading the « %{field} » file failed. Try again.",
    network: "Network error. Try again.",
    unknown: "The action failed. Try again.",
  },
};
